import { useState, useEffect } from 'react'
import { BotAdministrationView } from '../../views'
import { SimpleLoading, ModalUtil } from '../../pures'
import { LocalStorageService, UserService } from '../../../services'
import { useTranslation } from 'react-i18next'
import { useGlobalState } from '../../../GlobalState'
import 'moment/locale/es'

/**
 * @description main bot administration
 * @class BotAdministrationAction
 * @status no delete
 */
const BotAdministrationAction = () => {
  // #region variables
  const [initialLoading, setInitialLoading] = useState(true)
  const { chatbotList, setChatbotList, botConfig, setBotConfig } = useGlobalState()
  
  const url = process.env.REACT_APP_ETICKET_API
  const localStorageService = new LocalStorageService()
  const userService = new UserService(url)
  const token = localStorageService.getLocalStorageItem('token').idToken
  const modalUtil = new ModalUtil()
  const { t: tCommon } = useTranslation()
  const { t } = useTranslation('bot-administration')
  const botList = chatbotList?.map(bot => ({...bot, active: bot.active ? t('enable') : t('disable')}))
  // #endregion variables

  // #region methods
  /**
   * @description update bot status | active / deactivate
   * @author Antonio Vazquez
   * @createdDate 19-12-25
   * @param {String} id bot id
   */
  const updateBotStatus = async (id) => {
    modalUtil.showModal('loading', tCommon('modal.pure.loading.message'), tCommon('modal.pure.loading.title'))
    const bot = chatbotList?.find(bot => bot.id === id)

    try {
      if (bot) {
        const token = localStorageService.getLocalStorageItem('token', true)?.accessToken
        if (bot.active) {
          await userService.deactivateAssistant(id, token)
        } else {
          await userService.activateAssistant(id, token)
        }
        await handleGetAssistants(id)
        await modalUtil.showModal('success', !bot.active ? t('modal.successEnabled') : t('modal.successDisabled'), tCommon('modal.pure.title.success'))
      }
    } catch (e) {
      console.log(e)
      modalUtil.showModal('error', e.message || !bot.active ? t('modal.errorEnabled') : t('modal.errorDisabled'), tCommon('modal.pure.title.error'))
    }
  }

  /**
   * @author Antonio Vazquez
   * @description event to get user assistants
   * @createdDate 19-12-2025
   */
  const handleGetAssistants = async (botId) => {
    try {
      const token = localStorageService.getLocalStorageItem('token', true)?.accessToken
      const clientId = localStorageService.getLocalStorageItem('user', true)?.userMetaData?.userA3Cloud.clientId
      const response = await userService.getAssistants(clientId, token)
      setChatbotList(response)

      if (botId === botConfig.id) {
        setBotConfig(response?.filter(bot => bot.active)[0])
      }
    } catch (e) {
      console.error(`An error occurred in event getAssistants:: ${e}`)
    }
  }
  // #endregion methods

  // #region effects
  /**
   * @description init mount effect
   * @author Antonio Vazquez
   * @createdDate 19-12-25
   */
  useEffect(() => {
    // getInfo(true)
    setInitialLoading(false)
  }, [])
  // #endregion effects

  return (
    <>
      {
        initialLoading
          ? <div className='loading'>
            <SimpleLoading />
          </div>
          : <BotAdministrationView
            t={t}
            botList={botList || []}
            updateBotStatus={updateBotStatus}
          />
      }
    </>
  )
}

export { BotAdministrationAction as default }
